import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray, isPlainObject } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Select from '../select';

function handleDataSource(dataSource) {
  if (!isArray(dataSource)) {
    return null;
  }

  return dataSource.map(function (data) {
    if (!isPlainObject(data)) {
      return {
        value: data,
        label: data
      };
    }

    return data;
  });
}

export default {
  name: buildComponentName('Autocomplete'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-select'
    },
    dataSource: {
      type: Array,
      default: null
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    autoClearSearchValue: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Please Select'
    },
    popupClass: {
      type: [String, Object, Array],
      default: ''
    },
    popupStyle: {
      type: Object,
      default: null
    },
    transition: {
      type: String,
      default: 'slide-up'
    },
    dropdownMatchSelectWidth: {
      type: Boolean,
      default: true
    },
    dropdownMenuStyle: {
      type: Object,
      default: undefined
    },
    getContainer: {
      type: Function,
      default: null
    },
    filterOption: {
      type: [Function, Boolean],
      default: false
    },
    renderLabel: {
      type: Function,
      default: null
    },
    renderGroupLabel: {
      type: Function,
      default: null
    },
    lazy: {
      type: [Object, Boolean],
      default: true
    },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['', 'large', 'default', 'small'].indexOf(val) > -1;
      }
    },
    optionLabelProp: {
      type: String,
      default: 'children',
      validator: function validator(val) {
        return ['value', 'label', 'children'].indexOf(val) > -1;
      }
    },
    notFoundContent: {
      type: [String, Object],
      default: null
    },
    renderInputElement: {
      type: Function,
      default: null
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-show-search"), true), _defineProperty(_ref, "".concat(prefixCls, "-auto-complete"), true), _ref;
    },
    normalizeDataSource: function normalizeDataSource() {
      return handleDataSource(this.dataSource);
    },
    bindProps: function bindProps() {
      var $props = this.$props,
          normalizeDataSource = this.normalizeDataSource;
      return _objectSpread({}, $props, {
        dataSource: normalizeDataSource,
        mode: 'SECRET_COMBOBOX_MODE_DO_NOT_USE'
      });
    }
  },
  methods: {
    onInput: function onInput() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // 保证组件触发input事件, form表单验证时,需要组件自身触发事件
      this.$emit.apply(this, ['input'].concat(args));
    },
    onChange: function onChange() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // 保证组件触发change事件, form表单验证时,需要组件自身触发事件
      this.$emit.apply(this, ['change'].concat(args));
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        $scopedSlots = this.$scopedSlots,
        $listeners = this.$listeners,
        classes = this.classes,
        bindProps = this.bindProps,
        renderInputElement = this.renderInputElement,
        onInput = this.onInput,
        onChange = this.onChange;

    var on = _objectSpread({}, $listeners, {
      input: onInput,
      change: onChange
    });

    var slotRenderInputElement = ($slots.renderInputElement || [])[0];
    var getInputElement = slotRenderInputElement ? function () {
      return slotRenderInputElement;
    } : renderInputElement;
    return h(Select, _mergeJSXProps([{}, {
      class: classes,
      props: _objectSpread({}, bindProps, {
        getInputElement: getInputElement
      }),
      on: on,
      scopedSlots: {
        renderGroupLabel: $scopedSlots.renderGroupLabel,
        renderLabel: $scopedSlots.renderLabel
      }
    }]), [$slots.default]);
  }
};